import type { CurrencyCode, SupportedCurrencyCode } from 'apis/handler/exchange-rate';

type CurrencyMeta = {
  code: CurrencyCode;
  symbol: string;
};

export const CURRENCY_META: Record<CurrencyCode, CurrencyMeta> = {
  KRW: { code: 'KRW', symbol: '₩' },
  USD: { code: 'USD', symbol: '$' },
  JPY: { code: 'JPY', symbol: '¥' },
  CNY: { code: 'CNY', symbol: '¥' },
  EUR: { code: 'EUR', symbol: '€' },
  GBP: { code: 'GBP', symbol: '£' },
  HKD: { code: 'HKD', symbol: 'HK$' },
  CAD: { code: 'CAD', symbol: 'C$' },
  AUD: { code: 'AUD', symbol: 'A$' },
  INR: { code: 'INR', symbol: '₹' },
  VND: { code: 'VND', symbol: '₫' },
  SGD: { code: 'SGD', symbol: 'S$' },
};

// 모달에 노출할 통화 그룹 — 자주 쓰는 통화는 상단, 그 외는 하단
export const FREQUENTLY_USED_CURRENCY_CODES: CurrencyCode[] = ['KRW', 'USD', 'EUR', 'CNY'];
export const OTHER_CURRENCY_CODES: SupportedCurrencyCode[] = ['JPY', 'VND', 'GBP', 'HKD', 'SGD', 'AUD', 'CAD', 'INR'];

// 사이트 언어 → default 통화 매핑
// 첫 방문 시 자동 적용 + 모달에서 언어 chip 클릭 시 통화 draft도 함께 자동 매칭
export const LANGUAGE_DEFAULT_CURRENCY: Record<string, SupportedCurrencyCode> = {
  en: 'USD',
  vi: 'VND',
  zh: 'CNY',
  ja: 'JPY',
};

/**
 * KRW 금액을 선택 통화로 변환해 표시 문자열로 반환.
 * 통화별 문화권 기준 abbreviation:
 *   - JPY, CNY: 万 단위 (동아시아 관습)
 *   - 그 외: K/M 단위 (서구·국제 표준, Intl compact)
 */
export const formatForeign = (krw: number, rate: number, code: SupportedCurrencyCode): string => {
  const converted = Math.round(krw * rate);
  const symbol = CURRENCY_META[code].symbol;

  if (code === 'JPY' || code === 'CNY') {
    if (converted >= 10_000) {
      const wan = converted / 10_000;
      const formatted = Number.isInteger(wan) ? wan.toString() : wan.toFixed(1);
      return `${symbol}${formatted}万`;
    }
    return `${symbol}${new Intl.NumberFormat('en-US').format(converted)}`;
  }

  if (converted >= 1_000) {
    const formatter = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 });
    return `${symbol}${formatter.format(converted)}`;
  }
  return `${symbol}${converted}`;
};
